export default "__VITE_ASSET__DSOr6B$r__"